import {AdvertisementSelectData} from "../types/advertisement-initial-statistics-modal.types";

export const fraction: Array<AdvertisementSelectData> = [
  { id: 'ONE', value: '1/5' },
  { id: 'TWO', value: '2/5' },
  { id: 'THREE', value: '3/5' },
  { id: 'FOUR', value: '4/5' },
  { id: 'FIVE', value: '5/5' }
]

export const gender = [
  { id: 'MALE', value: 'f', label: 'Ж' },
  { id: 'FEMALE', value: 'm', label: 'М' }
];

export const severity: Array<AdvertisementSelectData> = [
  { id: 'NO', value: 'Нет - Отлично' },
  { id: 'MINOR', value: 'Мелочь' },
  { id: 'MODERATE', value: 'Средне' },
  { id: 'DOUBTFUL', value: 'Сомнительно' },
  { id: 'BAD', value: 'Плохо' }
]

export const rating: Array<AdvertisementSelectData> = [
  { id: 'GOOD', value: '5 - 100% зайдёт' },
  { id: 'PROBABLY', value: '4 - Наверное зайдёт' },
  { id: 'AVERAGE', value: '3 - средне' },
  { id: 'POORLY', value: '2 - слабо' },
  { id: 'NO', value: '1 - нет' }
]

export const region: Array<AdvertisementSelectData> = [
  { id: 'RUSSIA', value: 'Россия' },
  { id: 'BELARUS', value: 'Беларусь' },
  { id: 'KAZAKHSTAN', value: 'Казахстан' }
]

export const roscomRegistrationStatusOptions: Array<AdvertisementSelectData> = [
  { id: 'YES', value: 'Да' },
  { id: 'NO', value: 'Нет' },
  { id: 'AWAITING', value: 'Ожидаем' },
  { id: 'MANUAL_INPUT', value: 'Ручной ввод' },
  { id: 'LESS_10K_SUBS', value: 'Меньше 10 тыс.'}
]

const selectDataMap: Record<string, Array<AdvertisementSelectData>> = {
  targetAudienceQuality: fraction,
  bloggerBelief: rating,
  viewsBoosting: severity,
  roscomRegistrationStatus: roscomRegistrationStatusOptions,
  region: region
} as const;

export function getSelectDataByFieldName(fieldName: string): Array<AdvertisementSelectData> {
  return selectDataMap[fieldName as keyof typeof selectDataMap] ?? [];
}
